import { getLinks } from "../../../shared/functions/fns.nav";
import PhxHeader from "@phoenixreisen/mithrils/src/header";
import NavToggle from "./navigation.toggle.m";
import m from "mithril";
export const Header = {
    oninit({ state }) {
        state.links = null;
        state.error = null;
        getLinks()
            .then((links) => {
            state.links = links;
        })
            .catch((e) => {
            const error = e;
            state.error = error;
        })
            .finally(() => {
            m.redraw();
        });
    },
    view({ state, attrs }) {
        const { links } = state;
        const { version, headline, type } = attrs;
        const { noNav, noImg, SideNav, ShortNav } = attrs;
        const logoUrl = !type || type === "intern"
            ? (links === null || links === void 0 ? void 0 : links.LOGO.intern) || null
            : (links === null || links === void 0 ? void 0 : links.LOGO.extern) || "https://www.phoenixreisen.com";
        return [
            m("header", { class: `header header--${process.env.NAME}` },
                m("div", { class: "wrapper wrapper--large relative" },
                    !noNav && ShortNav && (m(ShortNav, { links: state.links, error: state.error })),
                    !noNav && SideNav && (m(NavToggle, { Nav: SideNav, links: state.links, error: state.error })),
                    m(PhxHeader, { url: logoUrl, version: version }))),
            !noImg && (m("article", { class: "img-headline" },
                m("div", { class: "wrapper wrapper--large" },
                    m("h1", null, headline)))),
            noImg && headline && (m("div", { class: "wrapper wrapper--large" },
                m("h1", null, headline),
                m("hr", null))),
        ];
    },
};
export default Header;
